import React, { FC, useMemo } from 'react'

import { Direction } from 'components/page/RatingWave/Rating.types'

import { ControlButtonContext } from './context/ControlButtonContext'
import { Desktop } from './Desktop'
import { Mobile } from './Mobile'

/** FYI:
 * Набор кнопок отличается на mobile и desktop(как набором и положением)
 * 1. В rating (dislike, union(chat и multi), like) - desktop.  chat, union(like, multi) - mobile
 * 2. В profile (union(chat, multi), like) - desktop. chat, union(like, multi)
 * Это полные набор
 * Три параметра влияют на отображение
 * 1. mobile, desktop (browser)
 * 2. place (profile|rating)
 * 3. Данные по анкете(voteable).
 *
 * Сначала разделили через 1 пункт, далее второй внутри desktop
 * 3 пункт отображение like на desktop и изменения union на mobile
 *
 */
export const ControlButtonsBar: FC<{
  scrollableNode: HTMLElement | null
  onHandleClick: (action: Direction) => void
}> = ({ scrollableNode, onHandleClick }) => {
  const valueMemo = useMemo(
    () => ({
      onHandleClick,
    }),
    [onHandleClick]
  )
  return (
    <ControlButtonContext.Provider value={valueMemo}>
      <Desktop />
      {scrollableNode && <Mobile scrollableNode={scrollableNode} />}
    </ControlButtonContext.Provider>
  )
}
